/* THIS FILE IS GENERATED. DO NOT EDIT */

import theme from 'base/components/standalone/Slider/theme';

export const SliderTheme = theme;
